/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiAdminDtoSetUserPasswordDto
 */
export interface WebApiAdminDtoSetUserPasswordDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoSetUserPasswordDto
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiAdminDtoSetUserPasswordDto
     */
    newPassword?: string | null;
}

/**
 * Check if a given object implements the WebApiAdminDtoSetUserPasswordDto interface.
 */
export function instanceOfWebApiAdminDtoSetUserPasswordDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoSetUserPasswordDtoFromJSON(json: any): WebApiAdminDtoSetUserPasswordDto {
    return WebApiAdminDtoSetUserPasswordDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoSetUserPasswordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoSetUserPasswordDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
    };
}

export function WebApiAdminDtoSetUserPasswordDtoToJSON(value?: WebApiAdminDtoSetUserPasswordDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'newPassword': value.newPassword,
    };
}

